import React, {useState} from 'react';
import PaperlessStatusEventsDialog from '../dialogs/PaperlessStatusEventsDialog';
import {MenuItem} from '@material-ui/core';
import {PEvent} from '../../../types/PEvent';
import {PaymentActionType} from './PaymentActionHelper';
import PaymentService from '../../../services/PaymentService';

const PaymentEventAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  const [statusDialog, setStatusDialog] = useState(false);
  const [paymentEvents, setPaymentEvents] = useState<PEvent[]>([] as PEvent[]);

  return (
    <>
      <MenuItem
        ref={ref}
        key={payment.id + 'events'}
        onClick={() => {
          setMenuAnchor(null);
          PaymentService.getPaymentEvents(payment.id).then((events) => {
            setPaymentEvents(events);
            setStatusDialog(true);
          });
        }}
      >
        {label}
      </MenuItem>
      <PaperlessStatusEventsDialog onlinePayment={payment} events={paymentEvents} open={statusDialog} onCancel={() => setStatusDialog(false)} />
    </>
  );
});

export default PaymentEventAction;
